import * as React from 'react'

import { observer } from 'mobx-react'

import { Switch } from '~/client/src/shared/components/shadcn-ui/switch'

interface IProps {
  isBookable: boolean
  onToggle: (value: boolean) => void | Promise<void>
}

function WorkflowResourceCell({ isBookable, onToggle }: IProps) {
  // Disable the toggle while its save (and, when disabling, the control-clear
  // cascade) is in flight so a fast off->on can't race.
  const [isSaving, setIsSaving] = React.useState(false)
  // The row can regroup/refetch out of the table the moment the save resolves,
  // so guard the reset against a mid-save unmount.
  const isMountedRef = React.useRef(true)
  React.useEffect(
    () => () => {
      isMountedRef.current = false
    },
    [],
  )

  const handleChange = async (value: boolean) => {
    setIsSaving(true)
    try {
      await onToggle(value)
    } finally {
      if (isMountedRef.current) setIsSaving(false)
    }
  }

  return (
    <div
      className="tw:flex tw:items-center"
      onClick={event => event.stopPropagation()}
    >
      <Switch
        checked={isBookable}
        disabled={isSaving}
        onCheckedChange={handleChange}
      />
    </div>
  )
}

export default observer(WorkflowResourceCell)
